import axiosInstance from "../Axios";

/**
 * Get Mail Template List
 */
async function getMailTemplates(params = {}) {
  try {
    const response = await axiosInstance.get("/mail-template", {
      params,
    });
    return response;
  } catch (error) {
    console.log("Error while fetching mail templates:", error);
    return {
      data: {
        data: {
          mailTemplates: [],
        },
      },
    };
  }
}

/**
 * Get Mail Template Details
 */
async function getMailTemplateDetails(id) {
  try {
    return await axiosInstance.get(`/mail-template/details/${id}`);
  } catch (error) {
    console.log("Error while fetching mail template details:", error);
    throw error;
  }
}

/**
 * Create Mail Template
 */
async function createMailTemplate(data) {
  try {
    return await axiosInstance.post("/mail-template/create", data);
  } catch (error) {
    console.log("Error while creating mail template:", error);
    throw error;
  }
}

/**
 * Update Mail Template
 */
async function updateMailTemplate(id, data) {
  try {
    return await axiosInstance.patch(`/mail-template/update/${id}`, data);
  } catch (error) {
    console.log("Error while updating mail template:", error);
    throw error;
  }
}

/**
 * Delete Mail Template
 */
async function deleteMailTemplate(id) {
  try {
    return await axiosInstance.delete(`/mail-template/delete/${id}`);
  } catch (error) {
    console.log("Error while deleting mail template:", error);
    throw error;
  }
}

export {
  getMailTemplates,
  getMailTemplateDetails,
  createMailTemplate,
  updateMailTemplate,
  deleteMailTemplate,
};